
// import app from 'flarum/app';
// import app from 'flarum/forum/app';

import render from './render';


app.initializers.add('censorbot', () => {
  // render corrected text in Posts and Title
  render();
});
